<ngx-mat-timepicker-face [color]="color"
						 [dottedMinutesInGap]="dottedMinutesInGap"
						 [faceTime]="minutesList"
						 [selectedTime]="selectedMinute"
						 [minutesGap]="minutesGap"
						 (timeChange)="minuteChange.next($event)"
						 [unit]="timeUnit.MINUTE"></ngx-mat-timepicker-face>
